import { useState } from "react"
import styled from "styled-components"

import { Checkbox, spacing, TextField } from "@minuthq/meatball-ui-react"
import { add, startOfDay } from "date-fns"

import {
  usePostGuest,
  usePostGuestTriggerWelcomeMessage,
} from "src/data/guests/queries/guestQueries"
import { MDialog } from "src/ui/Dialog/MDialog"
import { PhoneNumberInput } from "src/ui/PhoneNumberInput/PhoneNumberInput"

const FORM_ID = "create-sandbox-guest-form"

export function ParadiseHomeCreateSandboxGuestDialog({
  onClose,
  homeId,
  orgId,
  onGuestCreated,
}: {
  onClose: () => void
  homeId: string
  orgId: string
  onGuestCreated: (guestId: string) => void
}) {
  const [name, setName] = useState("")
  const [phoneNumber, setPhoneNumber] = useState("")
  const [triggerWelcomeMessage, setTriggerWelcomeMessage] = useState(true)
  const postHomeGuest = usePostGuest()
  const postGuestTriggerWelcomeMessage = usePostGuestTriggerWelcomeMessage()

  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault()

    postHomeGuest.mutate(
      {
        path: {
          home_id: homeId,
        },
        body: {
          name: `(sandbox) ${name}`,
          phone_number: phoneNumber || undefined,
          checkin_time: startOfDay(new Date()).toISOString(),
          checkout_time: add(startOfDay(new Date()), { days: 7 }).toISOString(),
        },
      },
      {
        onSuccess: (data) => {
          if (triggerWelcomeMessage) {
            postGuestTriggerWelcomeMessage.mutate({
              path: {
                organization_id: orgId,
                guest_id: data.guest_id,
              },
            })
          }
          onGuestCreated(data.guest_id)
          onClose()
        },
      }
    )
  }

  return (
    <MDialog
      title="Create sandbox guest"
      description="This will create a guest that starts their stay today and ends in 7 days."
      onClose={onClose}
      open={true}
      formId={FORM_ID}
      loading={postHomeGuest.isPending}
    >
      <Form id={FORM_ID} onSubmit={handleSubmit}>
        <TextField
          placeholder="Name"
          value={name}
          onChange={(e) => setName(e)}
          startAdornment="(sandbox)"
        />

        <PhoneNumberInput
          label="Phone number"
          value={phoneNumber}
          onChange={(value) => setPhoneNumber(value ?? "")}
        />

        <Checkbox
          label="Trigger welcome message upon creation"
          checked={triggerWelcomeMessage}
          onCheck={setTriggerWelcomeMessage}
        />
      </Form>
    </MDialog>
  )
}

const Form = styled.form`
  display: grid;
  gap: ${spacing.M};
`
